import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c5932ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = {
  key: 0,
  class: "detailRegion"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "flex locationDetailRow" }
const _hoisted_7 = { class: "detailAttribute" }
const _hoisted_8 = { class: "flex locationDetailRow" }
const _hoisted_9 = { class: "detailAttribute" }
const _hoisted_10 = { class: "flex locationDetailRow" }
const _hoisted_11 = { class: "detailAttribute" }
const _hoisted_12 = { class: "flex locationDetailRow" }
const _hoisted_13 = { class: "detailAttribute" }
const _hoisted_14 = { class: "flex locationDetailRow" }
const _hoisted_15 = { class: "detailAttribute" }
const _hoisted_16 = { class: "flex locationDetailRow" }
const _hoisted_17 = { class: "detailAttribute" }
const _hoisted_18 = { class: "flex locationDetailRow" }
const _hoisted_19 = { class: "detailAttribute" }
const _hoisted_20 = { class: "flex locationDetailRow" }
const _hoisted_21 = { class: "detailAttribute" }
const _hoisted_22 = { class: "text-center" }

import {onMounted, ref} from "vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {LocationService} from "@/utilities/services/entities/LocationService";
import {ErrorLocationType} from "@/utilities/enums/Enums";
import {LocationInfo} from "@/models/location/LocationInfo";
import {DisdiInfo} from "@/models/disdi/DisdiInfo";
import {$t} from "@/utilities/i18n/config";
import {CategoryService} from "@/utilities/services/entities/CategoryService";
import {CategoryInfo} from "@/models/category/CategoryInfo";



export default /*#__PURE__*/_defineComponent({
  __name: 'DisdiLocationDetailsTab',
  props: {
  data: DisdiInfo
},
  setup(__props) {

const props = __props




const locationService = new LocationService();
const categoryService = new CategoryService();

const contextLocation = ref<LocationInfo|null>(null);
const contextCategory = ref<CategoryInfo|undefined>(undefined);


const loading = ref<boolean>(false);

const getDetailedData = async()=>{
  contextLocation.value = await locationService.getLocationBySecondaryId(props.data.locationSecondaryId, ErrorLocationType.popup);
  contextCategory.value = (await categoryService.getCategories("display", ErrorLocationType.popup))?.find(c => c.id === props.data.categoryId);
}

onMounted(async()=>{
  loading.value = true;
  await getDetailedData();
  loading.value = false;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (contextLocation.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref($t)('popups.disdiDetails.location.title')), 1),
              _hoisted_4,
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref($t)('popups.disdiDetails.location.name')), 1),
                _createElementVNode("div", null, _toDisplayString(contextLocation.value.name), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_unref($t)('popups.disdiDetails.location.group2')), 1),
                _createElementVNode("div", null, _toDisplayString(contextLocation.value.group2Name), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_unref($t)('popups.disdiDetails.location.group1')), 1),
                _createElementVNode("div", null, _toDisplayString(contextLocation.value.group1Name), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_unref($t)('popups.disdiDetails.location.CCName')), 1),
                _createElementVNode("div", null, _toDisplayString(contextLocation.value.controlCenterName), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(_unref($t)('popups.disdiDetails.location.phoneNumber')), 1),
                _createElementVNode("div", null, _toDisplayString(contextLocation.value.contactInfo.phoneNumber ?? ""), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(_unref($t)('popups.disdiDetails.location.email')), 1),
                _createElementVNode("div", null, _toDisplayString(contextLocation.value.email), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, _toDisplayString(_unref($t)('popups.disdiDetails.location.street')), 1),
                _createElementVNode("div", null, _toDisplayString(contextLocation.value.contactInfo.street) + " " + _toDisplayString(contextLocation.value.contactInfo.streetNumber), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_unref($t)('popups.disdiDetails.location.city')), 1),
                _createElementVNode("div", null, _toDisplayString(contextLocation.value.contactInfo.postalCode) + " " + _toDisplayString(contextLocation.value.contactInfo.city), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, !loading.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_22, [
      _createVNode(LoadingSpinner)
    ], 512), [
      [_vShow, loading.value]
    ])
  ], 64))
}
}

})